var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from "styled-components";
import Icon from './IconBase';
function EyeIcon(props) {
    if (!(props.width || props.height)) {
        props = Object.assign(__assign({}, props), { width: 20 });
    }
    return (React.createElement(Icon, __assign({ "data-icon": 'eye', viewBox: "0 0 20 12" }, props),
        React.createElement("path", { fillRule: "nonzero", d: "M9.975.009c3.194-.152 6.478 1.707 9.852 5.52.237.268.23.705-.017.961-3.362 3.506-6.623 5.352-9.785 5.501-3.194.152-6.478-1.706-9.852-5.52-.237-.267-.23-.703.017-.96C3.552 2.004 6.813.158 9.975.01zM10 2C7.79 2 6 3.79 6 6s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z" }),
        React.createElement("circle", { cx: "10", cy: "6", r: "2" })));
}
export default styled(EyeIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
